import { experimentProperties } from "./experiments";
const TRACKING_KEY = "btk_growth_application_tracking";

/* --------------------------------------------------------------------------
 * Attribution
 * ----------------------------------------------------------------------- */

/**
 * Capture UTM parameters, the landing page and the referrer once, on the
 * first page of the session that sees them, and keep them for the rest of it.
 *
 * They have to be stored rather than read at submit time: someone arrives on
 * an ad-tagged homepage, browses to the GrowthPoints page and then applies, by
 * which point the URL carries no parameters and document.referrer is this
 * site. Reading them at submit would attribute every application to itself.
 */
export function captureTracking() {
  try {
    const stored = sessionStorage.getItem(TRACKING_KEY);
    if (stored) return { ...JSON.parse(stored), ...experimentProperties() };
  } catch {
    // Private mode, or storage disabled. Attribution is a nice-to-have;
    // losing it must not stop anyone applying.
  }

  const params = new URLSearchParams(window.location.search);
  const tracking = {};
  for (const key of ["utm_id", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "ad_id"]) {
    const value = params.get(key);
    if (value && /^[a-zA-Z0-9_. -]{1,120}$/.test(value)) tracking[key] = value;
  }
  tracking.landing_page = window.location.pathname;
  if (document.referrer && !document.referrer.startsWith(window.location.origin)) {
    try { tracking.referrer = new URL(document.referrer).origin; } catch { /* malformed referrer */ }
  }

  try {
    sessionStorage.setItem(TRACKING_KEY, JSON.stringify(tracking));
  } catch {
    /* see above */
  }
  return { ...tracking, ...experimentProperties() };
}

